var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import Typography from '../Typography';
import { formatNumberAsCurrency, getUniqueKey } from '../utils';
import { WrapBarGraphStyle, WrapLabelStyle, WrapBarStyle, BarStyle } from './styled';
const BarGraph = (_a) => {
    var props = __rest(_a, []);
    const { step, total, data, barWidth, gap, initialLabelType, finalLabelType, color } = props;
    const [selectedBar, setSelectedBar] = useState(null);
    const handleBarClick = (index) => {
        setSelectedBar((prevSelectedBar) => (prevSelectedBar === index ? null : index));
    };
    return (_jsxs(WrapBarGraphStyle, Object.assign({}, props, { children: [_jsx(WrapLabelStyle, Object.assign({}, props, { children: Array.from(Array(step + 1), (_, index) => index)
                    .reverse()
                    .map((elem) => (_jsxs(Typography, Object.assign({ color: "#5B5D71", style: {
                        fontSize: '10px',
                        fontWeight: 500,
                        textAlign: 'right',
                    } }, { children: [initialLabelType || '', formatNumberAsCurrency(Math.round(total * (elem / step))), finalLabelType || ''] }), `${elem}-label-name`))) })), _jsx("div", Object.assign({ style: {
                    display: 'flex',
                    gap,
                    padding: '60px 40px 40px 0px',
                } }, { children: data.map(({ value, label, title }, index) => {
                    return (_jsx(WrapBarStyle, Object.assign({ "data-testid": `bar-${index}`, onClick: () => handleBarClick(index), isSelected: selectedBar !== null && selectedBar !== index, label: label, title: title }, { children: _jsx(BarStyle, { color: color, isSelected: selectedBar === index, graphValue: (value * 100) / total, popUpText: `${initialLabelType || ''}${formatNumberAsCurrency(value) || 0}${finalLabelType || ''}`, size: barWidth, "data-testid": `bar-span-${index}` }) }), getUniqueKey()));
                }) }))] })));
};
BarGraph.defaultProps = {
    data: [],
    step: 5,
    total: 0,
    barWidth: '12px',
    gap: '20px',
    labelType: '',
    maxWidth: '100%',
    maxHeight: '300px',
};
export default BarGraph;
//# sourceMappingURL=index.js.map